import React from 'react';
import HeroSection from '../components/HeroSection';
import SocialProof from '../components/SocialProof';
import ProblemSection from '../components/ProblemSection';
import USPSection from '../components/USPSection';
import OfferSection from '../components/OfferSection';
import LeadCaptureForm from '../components/LeadCaptureForm';
import TrustSection from '../components/TrustSection';
import ClosingSection from '../components/ClosingSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-purple-900">
      <HeroSection />
      <SocialProof />
      <ProblemSection />
      <USPSection />
      <OfferSection />
      <LeadCaptureForm />
      <TrustSection />
      <ClosingSection />
      <Footer />
    </div>
  );
};

export default LandingPage;